__turbopack_context__.v({
  "sponsor_link": "SponsorshipLogos-module-scss-module__ksO7qa__sponsor_link",
  "sponsor_logo": "SponsorshipLogos-module-scss-module__ksO7qa__sponsor_logo",
  "sponsor_logos": "SponsorshipLogos-module-scss-module__ksO7qa__sponsor_logos",
  "sponsorship_logos_intro": "SponsorshipLogos-module-scss-module__ksO7qa__sponsorship_logos_intro",
  "sponsorship_logos_wrapper": "SponsorshipLogos-module-scss-module__ksO7qa__sponsorship_logos_wrapper",
});
